import styles from './DatePickerTooltip.module.scss';
import Box from '@/components/UI/box/Box';
type Props = {
  content: string;
  type: 'Right' | 'Left' | 'Center';
  show?: boolean;
};
const DatePickerTooltip = ({
  content,
  type,
  show = false
}: Props) => {
  let tooltipClass = styles.tooltip;
  if (type === 'Right') {
    tooltipClass += ` ${styles['tooltip-right']}`;
  } else if (type === 'Left') {
    tooltipClass += ` ${styles['tooltip-left']}`;
  } else if (type === 'Center') {
    tooltipClass += ` ${styles['tooltip-center']}`;
  }
  return <Box component={'section'} className={`${tooltipClass} ${styles[show ? 'show-tooltip' : 'hide-tooltip']}`} data-sentry-element="Box" data-sentry-component="DatePickerTooltip" data-sentry-source-file="DatePickerTooltip.tsx">
      {content}
    </Box>;
};
export default DatePickerTooltip;